import { Getters } from 'vuex-smart-module';
import SubpartnersSalesState from './state';

export default class SubpartnersSalesGetters extends Getters<SubpartnersSalesState> {}
